import styles from "./ClassPeriod.module.scss";

import moment from "moment";

import Chip from "../Chip/Chip";

const ClassPeriod = ({
  periodEvent,
  timeFrom,
  timeTo,
  category,
  className,
  showRestStudents,
}) => {
  // const momentDate = moment(periodEvent.fromTime);
  const handleShowStudentList = () => {
    showRestStudents(periodEvent.period.studentPeriods);
  };

  return (
    <div className={styles.classPeriodPreview}>
      <div className={styles.periodTime}>
        <span className={styles.periodTimeTo}>
          {moment(periodEvent.fromTime).format("DD/MM/YY")}
        </span>
        <span className={styles.periodTimeFrom}>
          {moment(periodEvent.fromTime).format("hh:mm")}
        </span>
        <span className={styles.periodTimeTo}>
          {moment(periodEvent.toTime).format("hh:mm")}
        </span>
      </div>
      <div className={styles.periodDetails}>
        <div className={styles.periodDetailsTextContainer}>
          <div className={styles.periodDetailsText}>
            <span className={styles.periodCategory}>
              {periodEvent.period.name}
            </span>
            <span className={styles.periodClass}>
              {periodEvent.period.class.name}
            </span>
          </div>
          {/* <div className={styles.periodDetailsBtn}>...</div> */}
        </div>
        <div
          className={styles.periodAttendance}
          onClick={handleShowStudentList}
        >
          {periodEvent.period.studentPeriods.map((student, index) => {
            if (student && index < 3) {
              return <Chip key={index} {...student.user} />;
            }
          })}
          {periodEvent.period.studentPeriods.length > 2 && (
            // TODO: btn za otvarani modal z listom studentu
            <span className={styles.restNumber} onClick={handleShowStudentList}>
              {periodEvent.period.studentPeriods.length - 3}+
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClassPeriod;
